import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getFleets = () => {
  return Helpers.get(Constants.FLEETS_URL);
};

export const saveFleet = (fleet) => {
  return Helpers.post(`${Constants.FLEETS_URL}`, {}, fleet);
};

export const getInstrumentsListForFleet = (fleetId) => {
  return Helpers.get(`${Constants.FLEETS_URL}/${fleetId}/instruments`);
};

export const getInstrumentsListForQuery = (query) => {
  return Helpers.get(`${Constants.FLEETS_URL}/preview/instruments`, {}, { query });
};

export const updateFleet = (fleetId) => {
  return Helpers.post(`${Constants.FLEETS_URL}/${fleetId}/update`);
};
